import React from 'react'
import { getInsertThreshold } from './constants'

const renderResultsWithBanner = ({
  items,
  renderItem,
  bannerNode,
  shouldInsertBanner,
  viewMode,
  gridCountInARow,
}) => {
  if (!shouldInsertBanner || !bannerNode) {
    return items.map((item, index) => renderItem(item, index))
  }

  const insertAfterIndex = getInsertThreshold(viewMode, gridCountInARow) - 1
  const nodes = []

  items.forEach((item, index) => {
    nodes.push(renderItem(item, index))
    if (index === insertAfterIndex) {
      if (viewMode === 'tile') {
        nodes.push(
          <div
            key="search-satisfaction-banner"
            style={{ flexBasis: '100%', width: '100%' }}
          >
            {bannerNode}
          </div>
        )
      } else {
        nodes.push(
          <React.Fragment key="search-satisfaction-banner">
            {bannerNode}
          </React.Fragment>
        )
      }
    }
  })

  return nodes
}

export default renderResultsWithBanner
